export default function Spinner() {
	return (
		<div className="flex items-center justify-center">
			<div className="w-10 h-10 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
		</div>
	)
}
